import { computed, inject, Injectable, signal } from '@angular/core';
import { Skin } from '@core/interfaces/skin.interface';
import { SessionService } from '@core/services/session.service';
import { SocketService } from '@core/services/socket.service';

@Injectable({
  providedIn: 'root',
})
export class UpgraderService {
  private socketService = inject(SocketService);
  private session = inject(SessionService);

  isUnder = signal(true);
  readonly selectedSkinsS = signal<Skin[]>([]);
  readonly selectedSkinsPriceS = computed(() => {
    return this.selectedSkinsS().reduce((a, b) => a + b.price, 0);
  });

  betAmount = signal<number>(0);
  chance = computed(() => {
    const chance = (this.betAmount() / this.selectedSkinsPriceS()) * 100 * 0.9;

    return Number.isNaN(chance) ? 0 : chance;
  });
  maxBetAmount = computed(() => {
    return Math.min(
      this.selectedSkinsPriceS() * 0.9,
      this.session.currentBalance()
    );
  });
  isValid = computed(() => {
    return this.chance() > 0.01 && this.betAmount() > 0;
  });
  isProcessing = signal(false);
  clientSeed = signal<string | null>(null);

  constructor() {
    this.socketService.socket.on('upgrader_seed', (seed: string) => {
      this.clientSeed.set(seed);
    });
  }

  setBetAmount(amount: number) {
    this.betAmount.set(amount);

    if (this.betAmount() > this.maxBetAmount()) {
      this.betAmount.set(this.maxBetAmount());
    }

    if (this.betAmount() < 0) {
      this.betAmount.set(0);
    }
  }

  toggleUnder(value: boolean) {
    this.isUnder.update(() => value);
  }

  async upgrade() {
    this.isProcessing.set(true);

    try {
      const [won, percentage, serialId] = await this.socketService.emitArgs(
        'upgrader_use',
        {
          amount: +this.betAmount().toFixed(2),
          upgrade: this.selectedSkinsPriceS(),
          type: this.isUnder() ? 'under' : 'over',
          balance: this.session.balanceType(),
        }
      );
      return { won, percentage, serialId };
    } catch {
      this.isProcessing.set(false);
      return null;
    } finally {
    }
  }
}
